module.exports = __webpack_public_path__ + "img/kommune-704.fc6c8b3c.svg";